export const TRIAL_VIDEO_ADDON = 'trial_video_addon';

export default TRIAL_VIDEO_ADDON;
